import { render, staticRenderFns } from "./realTimeMonitoringtwo.vue?vue&type=template&id=f351b80a&scoped=true"
import script from "./realTimeMonitoringtwo.vue?vue&type=script&lang=js"
export * from "./realTimeMonitoringtwo.vue?vue&type=script&lang=js"
import style0 from "./realTimeMonitoringtwo.vue?vue&type=style&index=0&id=f351b80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f351b80a",
  null
  
)

export default component.exports